module.exports = __webpack_public_path__ + "443b8454e675b931eaa179d137ab0405.svg";